import http from '@services/http'
import {
  IDeleteUserComment,
  IMyComments,
  ISaveUserComment,
  IToggleUserCommentLike,
  IUserComments,
} from '@protocol/comment'

export default {
  toggleCommentLike(data: IToggleUserCommentLike.Params): Promise<IToggleUserCommentLike.Schema> {
    return http.post('comment/toggleCommentLike', data || {})
  },
  fetchRecentComments(data: IUserComments.Params): Promise<IUserComments.Schema> {
    return http.get('comment/recentComments', data || {})
  },
  fetchComments(data: IUserComments.Params): Promise<IUserComments.Schema> {
    return http.get('comment/comments', data || {})
  },
  fetchMyComments(data: IMyComments.Params): Promise<IMyComments.Schema> {
    return http.get('comment/myComments', data || {})
  },
  saveComment(data: ISaveUserComment.Params): Promise<ISaveUserComment.Schema> {
    return http.post('comment/saveComment', data || {})
  },
  deleteComment(data: IDeleteUserComment.Params): Promise<IDeleteUserComment.Schema> {
    return http.post('comment/deleteComment', data || {})
  },
}
